import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ParallaxLayer = ({
  children,
  speed = 0.5,
  direction = 'vertical',
  className = '',
  offset = ['start end', 'end start'],
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset,
  });

  const range = 100 * speed;
  const transform = useTransform(scrollYProgress, [0, 1], [-range, range]);

  const style =
    direction === 'horizontal'
      ? { x: transform, willChange: 'transform' }
      : { y: transform, willChange: 'transform' };

  return (
    <motion.div ref={ref} className={className} style={style}>
      {children}
    </motion.div>
  );
};

export default ParallaxLayer;
